/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.MeetingSectionTopicAttachment = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The MeetingSectionTopicAttachment model module.
   * @module model/MeetingSectionTopicAttachment
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>MeetingSectionTopicAttachment</code>.
   * @alias module:model/MeetingSectionTopicAttachment
   * @class
   */
  var exports = function() {
    var _this = this;











  };

  /**
   * Constructs a <code>MeetingSectionTopicAttachment</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MeetingSectionTopicAttachment} obj Optional instance to populate.
   * @return {module:model/MeetingSectionTopicAttachment} The populated <code>MeetingSectionTopicAttachment</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('SectionTopicID')) {
        obj['SectionTopicID'] = ApiClient.convertToType(data['SectionTopicID'], 'Integer');
      }
      if (data.hasOwnProperty('FileName')) {
        obj['FileName'] = ApiClient.convertToType(data['FileName'], 'String');
      }
      if (data.hasOwnProperty('MimeType')) {
        obj['MimeType'] = ApiClient.convertToType(data['MimeType'], 'String');
      }
      if (data.hasOwnProperty('BlobStorageURI')) {
        obj['BlobStorageURI'] = ApiClient.convertToType(data['BlobStorageURI'], 'String');
      }
      if (data.hasOwnProperty('Embed')) {
        obj['Embed'] = ApiClient.convertToType(data['Embed'], 'Boolean');
      }
      if (data.hasOwnProperty('EmbeddedToDiscussion')) {
        obj['EmbeddedToDiscussion'] = ApiClient.convertToType(data['EmbeddedToDiscussion'], 'Boolean');
      }
      if (data.hasOwnProperty('IsImage')) {
        obj['IsImage'] = ApiClient.convertToType(data['IsImage'], 'Boolean');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} SectionTopicID
   * @default 0
   */
  exports.prototype['SectionTopicID'] = 0;
  /**
   * @member {String} FileName
   * @default ''
   */
  exports.prototype['FileName'] = '';
  /**
   * @member {String} MimeType
   * @default ''
   */
  exports.prototype['MimeType'] = '';
  /**
   * @member {String} BlobStorageURI
   * @default ''
   */
  exports.prototype['BlobStorageURI'] = '';
  /**
   * @member {Boolean} Embed
   * @default false
   */
  exports.prototype['Embed'] = false;
  /**
   * @member {Boolean} EmbeddedToDiscussion
   * @default false
   */
  exports.prototype['EmbeddedToDiscussion'] = false;
  /**
   * @member {Boolean} IsImage
   * @default false
   */
  exports.prototype['IsImage'] = false;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


